import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import searchListMain, { parentChildCheckbox } from "@/js/components/others/_search-list.js";

// エリアから探すブロック（物件種別で切り替え、選択エリアの件数を集計）
const setAreaSearch = () => {
    const block = document.querySelector(".c-blocks-area-search");
    if (block === null) return;

    const hit = block.querySelector(".c-blocks-area-search__hit");
    const countTarget = block.querySelector("[data-pickup-count]");
    const actionButtons = block.querySelectorAll(".c-blocks-area-search__actions button");

    // 物件種別ごとに件数集計アクションを設定
    const setAreaSearchCountAction = (type) => {
        const region = block.querySelector(`.c-blocks-area-search__region[data-mode="${type}"] [data-pickup-search]`);
        if (region === null) return;
        const countAction = new CountAction(region);
        countAction.on("countChange", (e) => {
            countUpAction(countTarget, e.count);
            if (e.count == 0) {
                hit.dataset.empty = "";
                actionButtons.forEach((button) => button.setAttribute("disabled", ""));
            } else {
                delete hit.dataset.empty;
                actionButtons.forEach((button) => button.removeAttribute("disabled"));
            }
            parentChildCheckbox();
        });
    };

    // 物件種別セレクトの切り替え
    const select = block.querySelector("select");
    if (select) {
        select.addEventListener("change", (e) => {
            const selectedType = e.currentTarget.value;
            // 件数リセット
            hit.dataset.empty = "";
            countTarget.innerText = "0";
            actionButtons.forEach((button) => button.setAttribute("disabled", ""));
            // チェック解除
            block.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
            });
            // 送信ボタンの form 属性を選択中の種別のフォームに向ける
            actionButtons.forEach((button) => button.setAttribute("form", `area-search-form-${selectedType}`));
            // 選択中の種別のみ表示
            block.querySelectorAll(".c-blocks-area-search__region").forEach((region) => {
                if (region.dataset.mode === selectedType) {
                    region.dataset.isShow = "";
                } else {
                    delete region.dataset.isShow;
                }
            });
        });
        select.dispatchEvent(new Event("change"));
    }

    // 物件種別ごとに件数集計を設定
    block.querySelectorAll(".c-blocks-area-search__region").forEach((region) => {
        setAreaSearchCountAction(region.dataset.mode);
    });

    searchListMain();
};

const homeIndex = () => {
    document.querySelectorAll("[data-home-async-section]").forEach((target) => {
        fetch(target.dataset.url, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then((response) => response.ok ? response.text() : "")
            .then((html) => {
                if (!html.trim()) {
                    return;
                }

                target.outerHTML = html;
            })
            .catch(() => {});
    });

    setAreaSearch();
};

export default homeIndex;
